export function enumToText(enumType: any, value?: number): string {
  if (
    !value ||
    enumType === undefined ||
    isNaN(value) ||
    value < 0 ||
    value > Object.keys(enumType).length / 2
  ) {
    return '';
  }

  const enumKey = Object.keys(enumType).find((key) => enumType[key] === value);

  if (!enumKey) {
    return '';
  }

  return enumKey.replace(/([a-z])([A-Z])/g, '$1 $2');
}
